import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from 'react-i18next';
import cn from "classnames";
import style from "./style.module.scss";
import { Link, useNavigate } from "react-router-dom";
import ReloadIcon from "../icons/ReloadIcon";
import CustomButton from "../../custom/custom-button/CustomButton";
import PlusIcon from "../icons/PlusIcon";
import NotificationIconNew from "../icons/NotificationIconNew";
import { Notification, Order } from "../../../services";
import UserProfileIcon from "../icons/UserProfileIcon";
import { useSelector } from "react-redux";
import { LanguageDropdown } from "../../LanguageSelector/LanguageSelector";
import AccessDeniedModal from "../SubscriptionModal/AccessDeniedModal";
import { useAirOrderLimit, useOrderLimit, useUserLimits } from "../../../hooks/useClientLimits";
import { User } from "../../../services";
import NotificationUserPopup from "../../notification/NotificationUserPopup";
import OrdersChatHub from "../chat/OrdersChatHub/OrdersChatHub";
import { InfoIcon } from "lucide-react";
import AppTooltip from "../AppTooltip/AppTooltip";

const HeaderContentNew = ({
  title = "",
  practicalTitle = "",
  practicalTitleTooltip = "",
  displayTitle = false,
  displayCreateBtn = false,
  displayExpeditorCreateBtn = false,
  displayPracticalBtn = false,
  displayReloadBtn = false,
  displayNotification = true,
  displayProfile = true,
  onPracticalBtnClick,
  onReload,
  isPartnersPage = false,
  isListsAviationPage = false,
  isPlusIcon = true,
  totalPartners = 0,
  onCreateBtnClick,
  createBtnPopup,
  }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state);
  const company = useSelector((state) => state.user.company);
  const { orderLimit } = useOrderLimit();
  const { airOrderLimit } = useAirOrderLimit();
  const { partnerLimit } = useUserLimits();

  const [notificationsTotal, setNotificationsTotal] = useState(undefined);
  const [lastUpdated, setLastUpdated] = useState(new Date());
  const [timeSinceUpdate, setTimeSinceUpdate] = useState(0);
  const [timerStopped, setTimerStopped] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);
  const [isDisplayModal, changeDisplayModal] = useState(false);
  const [isNotificationPopupOpen, setIsNotificationPopupOpen] = useState(false);
  const notificationRef = useRef(null);
  const [chatModalState, setChatModalState] = useState({
    isOpen: false,
    orderId: null,
    serviceType: "order",
  });

  const allowCreateOrder = user && (user?.role?.isUnlimited || orderLimit > 0);
  const allowCreateAirOrder = user && (user?.role?.isUnlimited || airOrderLimit > 0);

  useEffect(() => {
    console.log("partnerLimit", partnerLimit)
    console.log("totalPartners", totalPartners)
  }, [partnerLimit]);

  useEffect(() => {
    Notification.getUserNotificationsCount()
      .then((res) => setNotificationsTotal(res.data))
      .catch((err) => requestErrorDisplay(err));
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      const timeElapsed = Math.floor((new Date() - lastUpdated) / 1000);
      if (timeElapsed >= 3600) {
        setTimerStopped(true);
        clearInterval(timer);
      } else {
        setTimeSinceUpdate(timeElapsed);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [lastUpdated]);

  const formatTime = (seconds) => {
    if (timerStopped) {
      return t('headerContentNew.timeFormat.moreThanHour');
    }

    if (seconds < 60) {
      return t('headerContentNew.timeFormat.secondsAgo', { count: seconds });
    } else if (seconds < 3600) {
      const minutes = Math.floor(seconds / 60);
      return t('headerContentNew.timeFormat.minutesAgo', { count: minutes });
    }
    return '';
  };

  const handleReload = () => {
    setLastUpdated(new Date());
    setReloadKey((prevKey) => prevKey + 1);

    if (onReload) {
      onReload();
    }
  };

  const handleNotificationClick = () => {
    setIsNotificationPopupOpen(!isNotificationPopupOpen);
  };

  const handleNotificationPopupClose = () => {
    setIsNotificationPopupOpen(false);
  };

  const handleNotificationsUpdated = () => {
    Notification.getUserNotificationsCount()
      .then((res) => setNotificationsTotal(res.data))
      .catch((err) => console.error(err));
  };

  const handleOpenChat = (orderId, serviceType) => {
    setChatModalState({
      isOpen: true,
      orderId,
      serviceType,
    });
  };

  return (
    <>
      <div className={cn(style.wrapper)}>
        {displayTitle && <div className={style.title}>{title}</div>}

        {displayReloadBtn && (
          <div className={cn(style.reload)}>
            <ReloadIcon className={cn(style.reload_btn)} key={reloadKey} onClick={handleReload} />
            <div className={cn("d-flex flex-column")}>
              <h1 className={style.title}>{title}</h1>
              <span className={style.updatedTime}>{t('headerContentNew.updatedText', { time: formatTime(timeSinceUpdate) })}</span>
            </div>
          </div>
        )}

        {displayCreateBtn && (
          <>
            <div style={{ position: 'relative' }}>
              {onCreateBtnClick ? (
                <div
                  className={style.create__orders}
                  data-tooltip-id="header-tooltip-create-road"
                  style={{ cursor: 'pointer' }}
                  onClick={(e) => {
                    if (!allowCreateOrder) {
                      changeDisplayModal(true);
                      return;
                    }
                    onCreateBtnClick(e);
                  }}
                >
                  <CustomButton prefixStart={<PlusIcon fill="#fff" />} text={t('headerContentNew.buttons.createNewOrder')} isMain />
                  {user && user?.role && !user?.role?.isUnlimited && (
                    <span className={style.create__limits}> Осталось: {orderLimit} </span>
                  )}
                </div>
              ) : (
                <Link
                  className={style.create__orders}
                  to={allowCreateOrder ? "/orders/create" : "#"}
                  data-tooltip-id="header-tooltip-create-road"
                  onClick={(e) => {
                    if (!allowCreateOrder) {
                      e.preventDefault();
                      changeDisplayModal(true);
                      return;
                    }
                  }}
                >
                  <CustomButton prefixStart={<PlusIcon fill="#fff" />} text={t('headerContentNew.buttons.createNewOrder')} isMain />
                  {user && user?.role && !user?.role?.isUnlimited && (
                    <span className={style.create__limits}> Осталось: {orderLimit} </span>
                  )}
                </Link>
              )}
            </div>
            <AppTooltip id="header-tooltip-create-road" place="right" positionStrategy="fixed">
              {t('tooltips.createRoadTransportOrderHint')}
            </AppTooltip>
          </>
        )}

        {displayExpeditorCreateBtn && (
          <>
            <Link
              className={style.create__orders}
              to={allowCreateAirOrder ? "/expeditor/orders/create" : "#"}
              data-tooltip-id="header-tooltip-create-air"
              onClick={(e) => {
                if (!allowCreateAirOrder) {
                  e.preventDefault();
                  changeDisplayModal(true);
                  return;
                }
              }}
            >
              <CustomButton
                prefixStart={<PlusIcon fill="#fff" />}
                text={t("headerContentNew.buttons.createNewOrder")}
                isMain
              />
              {user && user?.role && !user?.role?.isUnlimited && (
                <span className={style.create__limits}> Осталось: {orderLimit} </span>
              )}
            </Link>
            <AppTooltip id="header-tooltip-create-air" place="bottom" positionStrategy="fixed">
              {t('tooltips.createRoadTransportOrderHint')}
            </AppTooltip>
          </>
        )}

        {practicalTitle && (
          <div className={style.create__orders}>
            <CustomButton
              prefixStart={isPlusIcon ? <PlusIcon fill="#fff" /> : ""}
              text={practicalTitle}
              isMain
              onClick={onPracticalBtnClick}
              isDark={isPlusIcon ? false : true}
              data-tooltip-id={practicalTitleTooltip ? "header-tooltip-practical" : undefined}
            />
            {practicalTitleTooltip && (
              <AppTooltip id="header-tooltip-practical" place="bottom" positionStrategy="fixed">
                {practicalTitleTooltip}
              </AppTooltip>
            )}
            {isPartnersPage && user && user?.role && !user?.role?.isUnlimited && (
              <span className={style.create__limits}>
                Осталось: {Math.max(0, partnerLimit - totalPartners)}
              </span>
            )}
            {isListsAviationPage && user && user?.role && !user?.role?.isUnlimited && (
              <span className={style.create__limits}>
                Осталось: {airOrderLimit}
              </span>
            )}
          </div>
        )}

        <div
          className={cn("ms-auto")}
          onClick={() => {
            const guidePath = user?.type === "Client" ? "/guide/shipper" : "/guide/expeditor";
            window.open(guidePath, "_blank");
          }}
          style={{ cursor: "pointer" }}
          data-tooltip-id="header-info-tooltip"
        >
          <InfoIcon size={24} color="#212121" />
        </div>
        <AppTooltip id="header-info-tooltip" place="bottom" positionStrategy="fixed">
          {t('tooltips.platformUsageGuide')}
        </AppTooltip>
        {displayNotification && (
          <>
            <div
              ref={notificationRef}
              className={cn(style.notification)}
              data-tooltip-id="header-tooltip-notification"
              onClick={handleNotificationClick}
            >
              <NotificationIconNew />
              <div className={style.notification_count}>{notificationsTotal}</div>
            </div>
            <AppTooltip id="header-tooltip-notification" place="bottom" positionStrategy="fixed">
              {t('tooltips.orderUpdates')}
            </AppTooltip>
          </>
        )}
        <div className={displayNotification ? "" : "ms-auto"}>
          <LanguageDropdown />
        </div>
        {displayProfile && (
          <div className={cn(style.profile)} onClick={() => navigate("/profile")}>
            <UserProfileIcon />
            <div className={style.profile_title}>
              <span>{company?.name}</span>
              <div className={style.profile_text}>{t('headerContentNew.profile.binLabel', { bin: user?.bin })}</div>
            </div>
          </div>
        )}
      </div>
      
      <div className={cn(style.wrapperMobile)}>
        {displayTitle && <div className={style.title}>{title}</div>}

        {displayReloadBtn && (
          <div className={cn(style.reload)}>
            <ReloadIcon className={cn(style.reload_btn)} key={reloadKey} onClick={handleReload} />
            <div className={cn("d-flex flex-column")}>
              <h1 className={style.title}>{title}</h1>
              <span className={style.updatedTime}>{t('headerContentNew.updatedText', { time: formatTime(timeSinceUpdate) })}</span>
            </div>
          </div>
        )}

        {displayCreateBtn && (
          <>
            <div style={{ position: 'relative' }}>
              {onCreateBtnClick ? (
                <div
                  className={style.create__orders}
                  data-tooltip-id="header-tooltip-create-road-mobile"
                  style={{ cursor: 'pointer' }}
                  onClick={(e) => {
                    if (!allowCreateOrder) {
                      changeDisplayModal(true);
                      return;
                    }
                    onCreateBtnClick(e);
                  }}
                >
                  <CustomButton prefixStart={<PlusIcon fill="#fff" />} text={t('headerContentNew.buttons.createNewOrder')} isMain />
                  {user && user?.role && !user?.role?.isUnlimited && (
                    <span className={style.create__limits}> Осталось: {orderLimit} </span>
                  )}
                </div>
              ) : (
                <Link
                  className={style.create__orders}
                  to={allowCreateOrder ? "/orders/create" : "#"}
                  data-tooltip-id="header-tooltip-create-road-mobile"
                  onClick={(e) => {
                    if (!allowCreateOrder) {
                      e.preventDefault();
                      changeDisplayModal(true);
                      return;
                    }
                  }}
                >
                  <CustomButton prefixStart={<PlusIcon fill="#fff" />} text={t('headerContentNew.buttons.createNewOrder')} isMain />
                  {user && user?.role && !user?.role?.isUnlimited && (
                    <span className={style.create__limits}> Осталось: {orderLimit} </span>
                  )}
                </Link>
              )}
            </div>
            <AppTooltip id="header-tooltip-create-road-mobile" place="bottom" positionStrategy="fixed">
              {t('tooltips.createRoadTransportOrderHint')}
            </AppTooltip>
          </>
        )}

        {displayExpeditorCreateBtn && (
          <>
            <Link
              className={style.create__orders}
              to={allowCreateAirOrder ? "/expeditor/orders/create" : "#"}
              data-tooltip-id="header-tooltip-create-air-mobile"
              onClick={(e) => {
                if (!allowCreateAirOrder) {
                  e.preventDefault();
                  changeDisplayModal(true);
                  return;
                }
              }}
            >
              <CustomButton prefixStart={<PlusIcon fill="#fff" />} text={t('headerContentNew.buttons.createNewOrder')} isMain />
              {user && user?.role && !user?.role?.isUnlimited && (
                <span className={style.create__limits}> Осталось: {orderLimit} </span>
              )}
            </Link>
            <AppTooltip id="header-tooltip-create-air-mobile" place="bottom" positionStrategy="fixed">
              {t('tooltips.createRoadTransportOrderHint')}
            </AppTooltip>
          </>
        )}

        {practicalTitle && (
          <div className={style.create__orders}>
            <CustomButton
              prefixStart={<PlusIcon fill="#fff" />}
              text={practicalTitle}
              isMain
              onClick={onPracticalBtnClick}
              data-tooltip-id={practicalTitleTooltip ? "header-tooltip-practical-mobile" : undefined}
            />
            {practicalTitleTooltip && (
              <AppTooltip id="header-tooltip-practical-mobile" place="bottom" positionStrategy="fixed">
                {practicalTitleTooltip}
              </AppTooltip>
            )}
            {isPartnersPage && user && user?.role && !user?.role?.isUnlimited && (
              <span className={style.create__limits}>
                Осталось: {Math.max(0, partnerLimit - totalPartners)}
              </span>
            )}
            {isListsAviationPage && user && user?.role && !user?.role?.isUnlimited && (
              <span className={style.create__limits}>
                Осталось: {airOrderLimit}
              </span>
            )}
          </div>
        )}
      </div>

      {displayCreateBtn ? createBtnPopup : null}

      {isDisplayModal && <AccessDeniedModal onClose={() => changeDisplayModal(false)} />}

      <NotificationUserPopup
        isOpen={isNotificationPopupOpen}
        onClose={handleNotificationPopupClose}
        referenceElement={notificationRef.current}
        onNotificationsUpdated={handleNotificationsUpdated}
        onOpenChat={handleOpenChat}
      />

      <OrdersChatHub
        isOpen={chatModalState.isOpen}
        orderId={chatModalState.orderId}
        onClose={() => setChatModalState({ isOpen: false, orderId: null, serviceType: "order" })}
        serviceType={chatModalState.serviceType}
      />
    </>
  );
};

export default HeaderContentNew;
